import { useEffect, useRef, useState } from 'react'
import { getCardReaderInfos } from '@services/CardReadService'
import { useAppDispatch } from './reduxHooks'
import { setReaderState } from '@state/reducers/appReducer'

export const useCardReaderHealthCheck = (intervalMs = 30000) => {
  const dispatch = useAppDispatch()
  const [lastChecked, setLastChecked] = useState<Date | null>(null)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const checkHealth = async () => {
    try {
      const result = await getCardReaderInfos()

      dispatch(setReaderState(result))

      setLastChecked(new Date())
    } catch (error) {
      console.error('Card reader health check failed:', error)

      setLastChecked(new Date())
    }
  }

  useEffect(() => {
    checkHealth()

    intervalRef.current = setInterval(checkHealth, intervalMs)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [intervalMs])

  return { lastChecked, refetch: checkHealth }
}
